import { render, staticRenderFns } from "./ImagesGallery.vue?vue&type=template&id=248dd03e&scoped=true&"
import script from "./ImagesGallery.vue?vue&type=script&lang=js&"
export * from "./ImagesGallery.vue?vue&type=script&lang=js&"
import style0 from "./ImagesGallery.vue?vue&type=style&index=0&id=248dd03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248dd03e",
  null
  
)

export default component.exports